import Cookies from 'js-cookie';
import { PVERIFY_KEY } from '../constants/applicationConstants';

export const setDataToCookies = (cookieName: string, cookieValue: string, options?: Object) => {
  Cookies.set(cookieName, cookieValue, {sameSite: 'None', secure: true , ...options });// need to remove :  sameSite: 'None', secure: true ,
};

export const getDataFromCookies = (cookieName: string): string => {
  return Cookies.get(cookieName) || "";
};

export const removeDataFromCookies= (cookieName: string) => {
  Cookies.remove(cookieName,{ sameSite: 'None', secure: true });
};

export const setDataToLocalStorage = (key: string, value: string) =>{
    localStorage.setItem(key, value);
}
  
export const getDataFromLocalStorage = (key: string) =>{
    return localStorage.getItem(key);
}

export const clearLocalStorage = () =>{
    localStorage.clear();
}

export const removeItemFromLocalStorage = (key: string) =>{
    return localStorage.removeItem(key);
}

export const setDataToSessionStorage = (key: string, value: string) => {
  sessionStorage.setItem(key, value);
}

export const removeItemFromSessionStorage = (key: string) => {
  return sessionStorage.removeItem(key);
}
//CS-1071 - Start
export const getSelectionsFromSession = () => {
  try {
    return JSON.parse(sessionStorage.getItem("selections") || '{}');
  } catch (error) {
    console.error("Error parsing sessionStorage data: ", error);
    return {};
  }
};

// Function to save selections to sessionStorage
export const setSelectionsToSession = (selections: { [key: string]: string }) => {
  try {
    sessionStorage.setItem("selections", JSON.stringify(selections));
  } catch (error) {
    console.error("Error saving to sessionStorage: ", error);
  }
};

// Function to save a specific selection for a page
export const saveSelectionForPage = (pageKey: string, rowId: string) => {
  const selections = getSelectionsFromSession();
  selections[pageKey] = rowId;
  setSelectionsToSession(selections);
};

// Function to retrieve the selection for a specific page
export const getSelectionForPage = (pageKey: string) => {
  const selections = getSelectionsFromSession();
  return selections[pageKey] || null;
};

//CS-1071 - End
export const getDataFromSessionStorage = (key: string) => {
  return sessionStorage.getItem(key);
}

export const setSearchCriteriaToSessionStorage = (listPage: string, criteriaObj: any) => {
  let searchCriterias = getDataFromSessionStorage("searchCriterias");
  let criterias = {};
  if (searchCriterias && searchCriterias.trim() !== "") {
    // CS-1984: guard JSON.parse — a corrupt existing container must be recovered (overwritten), not throw
    // criterias = JSON.parse(searchCriterias);
    try {
      criterias = JSON.parse(searchCriterias);
    } catch {
      criterias = {}; // CS-1984: corrupt container → start fresh
    }
    // @ts-ignore
    criterias[listPage] = criteriaObj;
    setDataToSessionStorage("searchCriterias", JSON.stringify(criterias));
  } else {
    criterias = {};
    // @ts-ignore
    criterias[listPage] = criteriaObj;
    setDataToSessionStorage("searchCriterias", JSON.stringify(criterias));
  }
}

export const getSearchCriteriaFromSessionStorage = (listPage: string) => {
  let searchCriterias = getDataFromSessionStorage("searchCriterias");
  if (searchCriterias && searchCriterias.trim() !== "") {
    let criterias = {};
    // CS-1984: guard JSON.parse — corrupt stored value must fail safe (undefined), not throw
    // criterias = JSON.parse(searchCriterias);
    try {
      criterias = JSON.parse(searchCriterias);
    } catch {
      return undefined; // CS-1984
    }
    // @ts-ignore
    return criterias[listPage];
  }
  return undefined;
}
//CS-1297 - Start
export const isPverifyAlreadyCalled = (patientId: any): boolean => {
  // CS-1984: guard JSON.parse — corrupt stored map must fail safe (false), not throw
  // const calledMap = JSON.parse(localStorage.getItem(PVERIFY_KEY) || '{}');
  let calledMap: any = {};
  try {
    calledMap = JSON.parse(localStorage.getItem(PVERIFY_KEY) || '{}');
  } catch {
    return false; // CS-1984
  }
  return calledMap?.[patientId] === true;
};

export const markPverifyAsCalled = (patientId: any): void => {
  // CS-1984: guard JSON.parse — corrupt stored map must be recovered ({}), still record the call
  // const calledMap = JSON.parse(localStorage.getItem(PVERIFY_KEY) || '{}');
  let calledMap: any = {};
  try {
    calledMap = JSON.parse(localStorage.getItem(PVERIFY_KEY) || '{}');
  } catch {
    calledMap = {}; // CS-1984: corrupt → start fresh
  }
  calledMap[patientId] = true;
  localStorage.setItem(PVERIFY_KEY, JSON.stringify(calledMap));
};
//CS-1297 - End